/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetTargetingAnalysisPathParams = NonNullable<
  operations['internalGetTargetingAnalysis']['parameters']['path']
>;

export type InternalGetTargetingAnalysisQueryParams = NonNullable<
  operations['internalGetTargetingAnalysis']['parameters']['query']
>;

export type InternalGetTargetingAnalysisRequestBody = OperationRequestBodyContent<
  operations['internalGetTargetingAnalysis']
>;

export interface Input extends InternalGetTargetingAnalysisPathParams {
  apiVersion?: string;
  query?: InternalGetTargetingAnalysisQueryParams;
  body: InternalGetTargetingAnalysisRequestBody;
}

export async function internalGetTargetingAnalysis(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST(
    '/internal/projects/{projectKey}/flags/{flagKey}/environments/{environmentKey}/targeting-analysis',
    {
      params: { path, query },
      body,
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
